import { InternalAxiosRequestConfig, AxiosRequestHeaders } from "axios";
import { getCsrfToken } from "../csrf-token";

export const csrfInterceptor = (config: InternalAxiosRequestConfig) => {
    // https://github.com/axios/axios/issues/5573#issuecomment-1644862647
    config.headers ??= {} as AxiosRequestHeaders;
    config.headers["X-CSRF-TOKEN"] = getCsrfToken();

    return config;
};
